const normalizeStatus = (value) => String(value || '').trim().toLowerCase();

export const resolvePaymentReceiptStatusCategory = (row) => {
  const status = normalizeStatus(row?.status_key || row?.status);
  const isCanceled = status === 'canceled' || status === 'cancelado' || status === 'cancelada' || Number(row?.is_active ?? 1) !== 1;

  if (isCanceled) {
    return 'canceled';
  }

  const relationType = normalizeStatus(row?.relation_type || row?.voucher_type || row?.type);
  if (['simple_note', 'simple-note', 'nota_simple', 'nota-simple', 'note'].includes(relationType)) {
    return 'simple_note';
  }

  return 'cfdi';
};

export const countPaymentReceiptsByStatus = (rows, statusKey) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  return safeRows.filter((row) => resolvePaymentReceiptStatusCategory(row) === statusKey).length;
};

export const buildPaymentReceiptStatusTabs = (rows, labels = {}) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  const activeRows = safeRows.filter((row) => resolvePaymentReceiptStatusCategory(row) !== 'canceled');

  return [
    { key: 'all', label: labels.all || 'Vigentes', count: activeRows.length, showCount: true },
    { key: 'cfdi', label: labels.cfdi || 'CFDI', count: countPaymentReceiptsByStatus(safeRows, 'cfdi'), showCount: true },
    { key: 'simple_note', label: labels.simple_note || 'Nota Simple', count: countPaymentReceiptsByStatus(safeRows, 'simple_note'), showCount: true },
    { key: 'canceled', label: labels.canceled || 'Cancelados', count: countPaymentReceiptsByStatus(safeRows, 'canceled'), showCount: true },
  ];
};

export const filterPaymentReceiptsByStatus = (rows, activeStatusTab) => {
  const safeRows = Array.isArray(rows) ? rows : [];

  if (activeStatusTab === 'all') {
    return safeRows.filter((row) => resolvePaymentReceiptStatusCategory(row) !== 'canceled');
  }

  return safeRows.filter((row) => resolvePaymentReceiptStatusCategory(row) === activeStatusTab);
};
